import env from './env';
import { hijackJumpInJM } from '@zero/acore-in-jm';
import { beInjectedInIframe } from '@/common/utils/beInectedIn';

// 如果在iframe下
if (beInjectedInIframe()) document.body?.classList?.add('acore-in-jm');

hijackJumpInJM({ env });
